import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		searchBar: {
			children: {
				callToAction: {
					height: '30px',
					width: '110px',
					color: '#fff',
					padding: {
						_value: '5px',
					},
					background: {
						_value: '#1A6AEA',
					},
					border: {
						_value: 'none',
						left: {
							_value: '1px solid black',
						},
					},
					box: {
						sizing: 'border-box',
					},
				},
				clearSearch: {
					height: '30px',
					background: {
						color: 'rgba(255, 255, 255, 0)',
					},
					border: {
						_value: 'none',
					},
					padding: {
						_value: '5px',
					},
					cursor: 'pointer',
					box: {
						sizing: 'border-box',
					},
					display: 'flex',
					flex: {
						direction: 'column',
					},
					justifyContent: 'center',
				},
				input: {
					height: '30px',
					width: '100%',
					border: {
						_value: 'none',
					},
					padding: {
						_value: '5px',
					},
					box: {
						sizing: 'border-box',
					},
				},
				label: {
					display: 'block',
				},
				minimumError: {
					color: 'red',
					display: 'inline-block',
					margin: {
						_value: '0 0 0 5px',
					},
				},
				searchInputWrapper: {
					border: {
						_value: '1px solid black',
					},
					display: 'flex',
					flex: {
						direction: 'row',
					},
				},
				wrapper: {

				},
			},
		},
		app: {
			children: {
				wrapper: {
					padding: {
						bottom: '20px',
					},
				},
			},
		},
		results: {
			children: {
				list: {
					listStyle: {
						type: 'none',
					},
					padding: {
						_value: '0'
					},
					display: 'block',
				},
				allResultsListItem: {
					border: {
						top: {
							_value: '1px solid #ccc',
						},
					},
					padding: {
						top: '10px',
					},
				},
				allResultsLink: {
					text: {
						decoration: 'none',
						transform: 'uppercase',
					},
					color: 'black',
				},
				listItem: {

				},
				groupHeading: {
					display: 'flex',
					flex: {
						direction: 'row',
					},
					border: {
						bottom: {
							_value: '1px solid #ddd',
						},
					},
				},
				groupList: {
					listStyle: {
						type: 'none',
					},
					padding: {
						_value: '0',
					},

				},
				groupListItem: {
					margin: {
						bottom: '15px',
					},
				},
				groupLabel: {
					flex: {
						_value: '1',
					},
				},
				groupRedirectLink: {
					text: {
						decoration: 'none',
					},
					color: 'black',
				},
				listItemLink: {
					text: {
						decoration: 'none',
					},
					color: 'black',
					lineHeight: '22px',
				},
			},
		},
	},
	theme: {
		base: {
			modal: {
				children: {
					modalWrapper: {
						top: '5%',
						right: '15%',
						left: '15%',
						position: 'fixed',
						display: 'flex',
						justifyContent: 'flex-start',
						flex: {
							direction: 'column',
						},
						background: {
							color: 'white',
						},
						box: {
							shadow: '0 5px 15px -5px',
						},
						border: {
							radius: '0.25em',
						},
						padding: {
							_value: '1em',
						},
						zIndex: '1001',
					},
					modalTitleBar: {
						display: 'flex',
						justifyContent: 'space-between',
						flex: {
							direction: 'row',
						},
						margin: {
							_value: '0 0 10px 0',
						},
					},
					modalHead: {
						margin: {
							_value: '0 0 10px 0',
						},
					},
					modalOpenIcon: {
						height: '16px',
						width: '16px',
					},
					modalOpenButton: {
						display: 'inline-flex',
						justifyContent: 'space-between',
						flex: {
							direction: 'row',
						},
						border: {
							_value: '1px solid #dee2e6',
						},
						background: {
							_value: 'none',
						},
						margin: {
							_value: '0 15px',
						},
						padding: {
							_value: '4px 2px',
						},
						cursor: 'pointer',
					},
					modalFooter: {
						margin: {
							_value: '10px 0 0 0',
						},
					},
					modalCloseIcon: {
						height: '16px',
						width: '16px',
					},
					modalCloseButton: {
						display: 'flex',
						justifyContent: 'space-between',
						flex: {
							direction: 'row',
						},
						border: {
							_value: 'none',
						},
						background: {
							_value: 'none',
						},
						cursor: 'pointer',
					},
					modalBody: {
						display: 'flex',
						margin: {
							_value: '0',
						},
						overflow: {
							y: 'auto',
						},
						flex: {
							grow: '1',
							direction: 'column',
						},
					},
					modalActions: {
						display: 'flex',
						justifyContent: 'flex-end',
						flex: {
							direction: 'row',
						},
						margin: {
							_value: '10px 0 0 0',
						},
					},
					modalActionClose: {
						outline: {
							_value: 'none',
						},
						text: { align: 'center' },
						box: {
							shadow: '2px 2px 0 rgb(0 0 0 / 10%)',
						},
						border: {
							style: 'solid',
							color: '#0588c5',
							radius: '3px',
							width: '1px',
						},
						justifyContent: 'center',
						align: {
							items: 'center',
						},
						background: {
							_value: '#03a9f4',
						},
						min: {
							height: '24px',
						},
						padding: {
							top: '4px',
							bottom: '4px',
							left: '8px',
							right: '8px',
						},
						margin: {
							_value: '0 5px 0 0',
						},
						color: '#ffffff',
						cursor: 'pointer',
						selectors: {
							':hover': {
								border: {
									color: '#05a2eb',
								},
								background: {
									color: '#00aeff',
								},
							},
						},
					},
					modalAction: {
						outline: {
							_value: 'none',
						},
						text: { align: 'center' },
						box: {
							shadow: '2px 2px 0 rgb(0 0 0 / 10%)',
						},
						border: {
							style: 'solid',
							color: '#dee2e6',
							radius: '3px',
							width: '1px',
						},
						justifyContent: 'center',
						align: {
							items: 'center',
						},
						background: {
							_value: '#f8f9fa',
						},
						min: {
							height: '24px',
						},
						padding: {
							top: '4px',
							bottom: '4px',
							left: '8px',
							right: '8px',
						},
						margin: {
							_value: '0 5px 0 0',
						},
						cursor: 'pointer',
						selectors: {
							':hover': {
								border: {
									color: '#ebeef0',
								},
								background: {
									color: '#fcfcfc',
								},
							},
						},
					},
				},
			},
			input: {
				min: {
					width: '400px'
				}
			}
		}
	},
};
